import { render, staticRenderFns } from "./c-shared-configs-table.vue?vue&type=template&id=11d948f3"
import script from "./c-shared-configs-table.vue?vue&type=script&lang=js"
export * from "./c-shared-configs-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11d948f3')) {
      api.createRecord('11d948f3', component.options)
    } else {
      api.reload('11d948f3', component.options)
    }
    module.hot.accept("./c-shared-configs-table.vue?vue&type=template&id=11d948f3", function () {
      api.rerender('11d948f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/mconfigs/views/shared/c-shared-configs-table.vue"
export default component.exports